const API_HEADERS = {
  ACCOUNT_ID: "accountid"
};
export {
  API_HEADERS
};
